/**
 * @fileoverview チュートリアル永続化ヘルパ
 */

import gameState from '../../core/game-state.js';
import { STATE_PATHS } from '../../shared/constants/state-paths.js';

const DEFAULT_STATUS = {
  status: 'pending',
  completedAt: null,
};

function mergeStatus(partial) {
  return {
    ...DEFAULT_STATUS,
    ...partial,
  };
}

export function getOnboardingStatus() {
  const stored = gameState.getState(STATE_PATHS.SETTINGS_TUTORIAL_ONBOARDING);
  return mergeStatus(stored || {});
}

export function saveOnboardingStatus(partial, action = 'tutorial_onboarding_save') {
  const next = mergeStatus(partial);
  gameState.setState(STATE_PATHS.SETTINGS_TUTORIAL_ONBOARDING, next, action);
  return next;
}

export function markCompleted() {
  return saveOnboardingStatus(
    {
      status: 'completed',
      completedAt: Date.now(),
    },
    'tutorial_onboarding_completed',
  );
}

export function markSkipped() {
  return saveOnboardingStatus(
    {
      status: 'skipped',
      completedAt: null,
    },
    'tutorial_onboarding_skipped',
  );
}

export function resetOnboarding() {
  return saveOnboardingStatus(DEFAULT_STATUS, 'tutorial_onboarding_reset');
}
